<template>
  <div>
    <arkidian
      style="margin:auto; background-color:#ececec; border-radius:50%; width:400px; margin-top:100px; margin-bottom:40px "
      :preferencias="preferencias"
    ></arkidian>
    <div>
      <div class="container; margin:auto;width:400px;">
        <div class="row" style="width:400px; justify-content: center; display:block; margin:auto">
          <div class="container">
            <div class="row" style="justify-content: center; border-radius:15px">
              <div v-for="colorSelected in colors" v-bind:key="colorSelected">
                <div
                  :style="'width:30px; height:30px; background: '+colorSelected"
                  @click="seleccionaColor(colorSelected)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container; margin:auto; width:400px;">
      <div class="row" style="width:400px; justify-content: center; display:block;margin:auto">
        <div class="container">
          <div class="row" style="justify-content: center">
            <div v-for="body in bodies" v-bind:key="body">
              <img
                :src="'public/images/arkidians/'+ body+'.svg'"
                style="background-color:#ececec; border-radius:50%; width:100px; margin:10px"
                class="img img-rounded img-fluid"
                @click="seleccionaBody(body)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="container; margin:auto; width:400px;">
        <div class="row" style="width:400px; justify-content: center; display:block;margin:auto">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div v-for="face in faces" v-bind:key="face">
                <img
                  :src="'public/images/arkidians/'+ face+'.svg'"
                  style="background-color:#ececec; border-radius:50%; width:100px; margin:10px"
                  class="img img-rounded img-fluid"
                  @click="seleccionaFace(face)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="container; margin:auto; width:400px;">
        <div class="row" style="width:400px; justify-content: center; display:block;margin:auto">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div v-for="hair in hairs" v-bind:key="hair">
                <img
                  :src="'public/images/arkidians/'+ hair+'.svg'"
                  style="background-color:#ececec; border-radius:50%; width:100px; margin:10px"
                  class="img img-rounded img-fluid"
                  @click="seleccionaHair(hair)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button @click="altaAvatar(preferencias,usuario)">Alta</b-button>
      <b-button @click="consultaAvatar(usuario)">Consulta</b-button>
      <b-button @click="modificaAvatar(preferencias,usuario)">Modifica</b-button>
    </div>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import Arkidian from "./shared/Arkidian";
import { mapGetters } from "vuex";

export default {
  name: "app",
  components: {
    lottie: Lottie,
    arkidian: Arkidian
  },
  computed: {
    ...mapGetters(["pathAPI"])
  },
  data() {
    return {
      preferencias: {
        animated: true,
        color: "fill: #7E57C2;",
        body: "body4",
        hair: "hair3",
        face: "face2"
      },
      usuario: "bauti",
      bodies: ["body", "body2", "body3", "body4", "body5", "body6"],
      faces: ["face1", "face2"],
      hairs: ["hair1", "hair2", "hair3", "hair4"],
      colors: [
        "#FF6F00",
        "#EF6C00",
        "#FF6D00",
        "#FF7043",
        "#FF5722",
        "#F4511E",
        "#E64A19",
        "#FF3D00",
        "#E57373",
        "#F44336",
        "#E53935",
        "#D32F2F",
        "#FF1744",
        "#EC407A",
        "#E91E63",
        "#D81B60",
        "#FF4081",
        "#F50057",
        "#AB47BC",
        "#BA68C8",
        "#D500F9",
        "#AA00FF",
        "#7E57C2",
        "#651FFF",
        "#5C6BC0",
        "#3D5AFE",
        "#2196F3",
        "#1E88E5",
        "#0288D1",
        "#40C4FF",
        "#448AFF",
        "#03A9F4",
        "#039BE5",
        "#00B0FF",
        "#00BCD4",
        "#00ACC1",
        "#26A69A",
        "#66BB6A",
        "#4CAF50",
        "#43A047",
        "#8BC34A",
        "#7CB342",
        "#558B2F",
        "#AFB42B",
        "#FBC02D",
        "#FDD835",
        "#8D6E63",
        "#757575",
        "#616161",
        "#90A4AE",
        "#78909C",
        "#607D8B"
      ]
    };
  },
  methods: {
    seleccionaColor(color) {
      this.preferencias.color = "fill:" + color;
      console.log(color);
    },
    seleccionaBody(body) {
      this.preferencias.body = body;
      console.log(body);
    },
    seleccionaFace(face) {
      this.preferencias.face = face;
      console.log(face);
    },
    seleccionaHair(hair) {
      this.preferencias.hair = hair;
      console.log(hair);
    },

    consultaAvatar(usuario) {
      var self = this;
      fetch(self.pathAPI + "arkidianUsuario.php?usuario=" + usuario)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          self.preferencias.animated=true
          self.preferencias.color='fill:#'+data.color
          self.preferencias.body=data.cuerpo
          self.preferencias.hair=data.pelo
          self.preferencias.face=data.cara

        });
    },

    modificaAvatar(preferencias,usuario) {
      console.log(preferencias)
      var bodyApi;
      bodyApi =
        "usuario=" +
        usuario +
        "&color=" +
        preferencias.color.substring(6, 12) +
        "&cara=" +
        preferencias.face +
        "&cuerpo=" +
        preferencias.body +
        "&pelo=" +
        preferencias.hair;
        console.log(bodyApi)
      fetch(this.pathAPI + "arkidianUsuario.php?" + bodyApi, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "OK") {
            console.log("Modificado");
          } else {
            console.log(data);
          }
        });
    },

    altaAvatar(preferencias,usuario) {
      var self = this;
      //      self.errorMessage = "";
      //      self.successMessage = "";

      var bodyApi = "";

      bodyApi =
        "usuario=" +
        usuario +
        "&color=" +
        preferencias.color.substring(6, 12) +
        "&cara=" +
        preferencias.face +
        "&cuerpo=" +
        preferencias.body +
        "&pelo=" +
        preferencias.hair;

      fetch(this.pathAPI + "arkidianUsuario.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado == "ERROR") {
              //self.errorMessage = result.mensaje;
              console.log(result.mensaje);
            } else {
              // self.successMessage = "Arkidian dado de alta";
              console.log(result.mendaje);
            }
          });
        } else {
          self.errorMessage = "Hay un error, verificá los datos ingresados";
        }
      });
    }
  },
  mounted: function() {
    this.colors.sort;
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Test.vue